import { Button } from '@cropler/ui-kit';
import dayjs from 'dayjs';

import styles from '../styles.module.scss';
import { GanttItemHeight, GanttItemInnerHeight } from '../constants/index.jsx';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

export const GanttEditLocationButtonObject = ({ location, onClickButton }) => {
  return {
    id: 'edit-location' + location.id,
    group: location.id,
    title: (
      <div className={`${styles.ganttLineEdit} ${styles.ganttLineEditSmall}`} title="">
        <Button onClick={onClickButton} size={'small'} type={'text'} icon={<CroplerIcon name="editLine" />} />
      </div>
    ),
    canMove: false,
    canResize: false,
    height: GanttItemInnerHeight,
    start_time: dayjs(location.removal_date).subtract(1, 'day'),
    end_time: dayjs(location.removal_date),
    className: 'rct-item--edit-location',
  }
}

export const GanttEditSeasonButton = ({ id, season, today, onClickButton }) => {
  return {
    id: 'edit' + season.id,
    group: id,
    title: (
      <div className={styles.ganttLineEdit} title="">
        <Button
          onClick={onClickButton}
          size={'small'}
          type={'text'}
          icon={<CroplerIcon name="editLine" />}
        />
      </div>
    ),
    canMove: false,
    canResize: false,
    height: GanttItemHeight,
    start_time: dayjs(season.harvest_date).subtract(1, 'day') || dayjs(today),
    end_time: dayjs(season.harvest_date || today),
  }
}

export const GanttEditSmallLineButton = ({ id, groupId, endDate, onClickEdit, onClickDelete }) => {
  return {
    id: 'edit' + id,
    group: groupId,
    title: (
      <div className={`${styles.ganttLineEdit} ${styles.ganttLineEditDevices}`} title="">
       <div className={styles.ganttLineEditDevicesInner}>
         <Button
           onClick={onClickDelete}
           size={'small'}
           type={'text'}
           icon={<CroplerIcon name="remove" />}
         />
         <Button
           onClick={onClickEdit}
           size={'small'}
           type={'text'}
           icon={<CroplerIcon name="editLine" />}
         />
       </div>
      </div>
    ),
    canMove: false,
    canResize: false,
    height: GanttItemHeight,
    start_time: dayjs(endDate).subtract(1, 'day'),
    end_time: dayjs(endDate),
  }
}